import * as React from 'react';
import CardMui from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import styles from './card.module.css'

export default function Card({tramite}) {

    const title = tramite?.title
    const color = tramite?.color || 'black'
    const icon = tramite?.icon
    const url = tramite?.navegator

  return (
    <a href={url} className={styles.link}>
      <div className={styles.card}>
       {icon}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" style={{fontSize:15, color:color}}>
           {title}
          </Typography>
        </CardContent>
      </div>
      </a>
  );
}
